import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class BooxCookieService {

  constructor(
    private cookie: CookieService
  ) { }

  setCookie(name: string, value: string, days: number) {
    this.cookie.set(name, value, days);
  }

  getCookie(name: string): string {
    return this.cookie.get(name);
  }

  deleteCookie(name: string) {
    this.cookie.delete(name);
  }
}
